import { render, staticRenderFns } from "./Surveyintro.vue?vue&type=template&id=6f8b1e92&"
import script from "./Surveyintro.vue?vue&type=script&lang=js&"
export * from "./Surveyintro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports